import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LazyChatWidget } from '@components/LazyChatWidget/LazyChatWidget';
import { useDocumentTitle } from '@hooks';

export function AppLayout() {
  useDocumentTitle();
  return (
    <div className="bg-app-background">
      <Suspense fallback={null}>
        <LazyChatWidget />
      </Suspense>
      <Outlet />
    </div>
  );
}
